// extracted by mini-css-extract-plugin
export default {"thankyou":"style_thankyou__rKy+n","banner":"style_banner__YqF+a","row":"style_row__ZbV+D","grid":"style_grid__cPYau","desc":"style_desc__ZJeQK","tBtn":"style_tBtn__udpLa"};